module.exports = __webpack_public_path__ + "img/star.3df276fa.png";